export default __webpack_public_path__ + "static/media/Zambrano.2f184343.jpg";